export const calcMarginLeft = (level: number) => `${1.5 + level * 1.5}rem`
